import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type OpenItemsDialogViewModel } from './OpenItemsDialogViewModel'
import { OpenItemsDialog } from '@/features/jobs/details/components/JobProgressionCard/OpenItemsProgressionActions/OpenItemsDialog'

export interface OpenItemsDialogContainerProps {
  vm: OpenItemsDialogViewModel
}

export const OpenItemsDialogContainer = observer(
  function OpenItemsDialogContainer({ vm }: OpenItemsDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <OpenItemsDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isReportPending={vm.answerOpenItems.pending}
        onClose={vm.modal.close}
        onReport={vm.answerOpenItems}
      />
    )
  },
)
